import {DestroyRef, inject, Injectable} from '@angular/core';
import {merge} from 'rxjs';
import {filter, switchMap, tap} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EVENT_BUS} from '@shared/domain/tokens/event-bus.token';
import {PaymentBookingCompletedEvent} from '../../../payment/application/events/payment-booking-completed.event';
import {FetchAccountUseCase} from '../use-cases/fetch-account.use-case';
import {LinkBookingUseCase} from '../use-cases/link-booking.use-case';
import {AccountActivatedEvent} from "@shared/application/events/account/account-activated.event";
import {
  BookingActivationFinishedEvent
} from "@shared/application/events/booking/booking-activation-finished.event";
import {BookingFetchedEvent} from "@shared/application/events/booking/booking-fetched.event";

@Injectable({providedIn: 'root'})
export class ActivateAccountSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly fetchAccount = inject(FetchAccountUseCase);
  private readonly linkBooking = inject(LinkBookingUseCase);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    merge(
      this.eventBus.ofType(BookingFetchedEvent),
      this.eventBus.ofType(BookingActivationFinishedEvent),
      this.eventBus.ofType(PaymentBookingCompletedEvent)
    )
      .pipe(
        filter((event) => !!event.booking.accountId),
        switchMap(({booking}) =>
          this.fetchAccount.execute(booking.accountId).pipe(
            tap((account) => this.linkBooking.execute(account, booking.id)),
            tap((account) => this.eventBus.publish(new AccountActivatedEvent(account)))
          ),
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
